/**
 * sectionOverridesStore — persists per-section AI prompt overrides.
 *
 * Sections: adCopy | variantConcept | variantImage | variantVideo |
 *           blogContent | blogCss | videoImage | videoMotion
 *
 * App.jsx calls initSectionOverrides(data) after loading user_settings.
 * Every write calls _onChange so App.jsx can persist to Supabase.
 */

const LS_KEY = "creative_section_overrides_v1";

let _mem = {};
let _onChange = null;

export function initSectionOverrides(data = {}) {
  _mem = { ...(data || {}) };
  try { localStorage.setItem(LS_KEY, JSON.stringify(_mem)); } catch {}
}

export function onSectionOverridesChange(fn) {
  _onChange = fn;
}

function _flush() {
  try { localStorage.setItem(LS_KEY, JSON.stringify(_mem)); } catch {}
  _onChange?.({ ..._mem });
}

function _localFallback() {
  try { return JSON.parse(localStorage.getItem(LS_KEY) || "{}"); }
  catch { return {}; }
}

function _current() {
  return Object.keys(_mem).length > 0 ? _mem : _localFallback();
}

export function getSectionOverride(section) {
  return _current()[section] || {};
}

export function setSectionOverride(section, overrides) {
  const cur = _current();
  if (!overrides || Object.values(overrides).every((v) => !v)) {
    delete cur[section];
    _mem = cur;
  } else {
    _mem = { ...cur, [section]: overrides };
  }
  _flush();
}

export function resetSectionOverride(section) {
  const cur = { ..._current() };
  delete cur[section];
  _mem = cur;
  _flush();
}

export function resetAllSectionOverrides() {
  _mem = {};
  _flush();
}

export function hasSectionOverride(section) {
  const ov = _current()[section] || {};
  return Object.values(ov).some(Boolean);
}

export function getAllSectionOverrides() {
  return { ..._current() };
}
